import SingleInputPropertiesHelper from "./helpers/SingleInputPropertiesHelper";

function OnModified(sender: any, options: any) {
  if (options.type === "THEME_MODIFIED") {
    if (options.value.backgroundImage === undefined && sender.JSON.backgroundImage !== undefined) {
      const value = sender.JSON;
      delete value.backgroundImage;
      sender.JSON = value;
    }
  }

  if (options.type === "QUESTION_CONVERTED") {
    SingleInputPropertiesHelper(options.newValue);
  }

  if (
    options.type === "PROPERTY_CHANGED" &&
    options.name === "inputType" &&
    options.target?.getType?.() === "text"
  ) {
    options.target.clearErrors?.();
    options.target.inputType = options.newValue;
    SingleInputPropertiesHelper(options.target);
  }
}

export default OnModified;
